"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, ko*/
(function () {
  ko.components.register('kobo-message-box', {
    viewModel: function viewModel(params) {
      return new MessageBoxViewModel(params);
    },
    template: Kobo.$('#kobo-message-box-template').html()
  });
})();

var MessageBoxViewModel = /*#__PURE__*/function () {
  function MessageBoxViewModel(options) {
    _classCallCheck(this, MessageBoxViewModel);

    var name = options.name,
        messages = options.messages,
        retrievesFromKeys = options.retrievesFromKeys;
    this.name = name;
    this.messages = ko.observableArray();
    this.setupEvents();
    this.initializeWithMessages(messages);
    this.setMessagesFromStoredMessages(retrievesFromKeys);
  }

  _createClass(MessageBoxViewModel, [{
    key: "add",
    value: function add(message) {
      this.messages.push(message);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this.messages.removeAll();
    }
  }, {
    key: "clear",
    value: function clear(message) {
      this.messages.remove(message);
    }
    /**
     * Stores a message in session storage given the provided key.
     * This is primarily used for when the status of an action performed on one page needs to be
     * shown on another page after a redirect. This is used in conjunction with setMessagesFromStoredMessages.
     * @param {string} messageKey
     * @param {object} message
     * @return {void}
     */

  }, {
    key: "storeMessage",
    value: function storeMessage(messageKey, message) {
      sessionStorage.setItem(messageKey, ko.toJSON(message));
    }
    /**
     * Retrieves messages from session storage given the provided keys to be added to the message box.
     * This is primarily used for when the status of an action performed on one page needs to be
     * shown on another page after a redirect. This is used in conjunction with storeMessage.
     * Drops stored messages on retrieval.
     * @param {Array.<string>} retrievesFromKeys
     * @return {void}
     */

  }, {
    key: "setMessagesFromStoredMessages",
    value: function setMessagesFromStoredMessages(retrievesFromKeys) {
      var _this = this;

      if (!retrievesFromKeys) {
        return;
      }

      retrievesFromKeys.forEach(function (messageKey) {
        var message = sessionStorage.getItem(messageKey);

        if (message) {
          _this.add(JSON.parse(message));

          sessionStorage.removeItem(messageKey);
        }
      });
    }
    /**
     * Sets up the mediator events for the message box.
     * Event handers are only called if the recipient name from the message matches the name of the message box.
     * This allows for multiple message boxes to be used on the same page without interfering with each other.
     */

  }, {
    key: "setupEvents",
    value: function setupEvents() {
      Kobo._mediator.register('kobo-message-box::add');

      Kobo._mediator.subscribe('kobo-message-box::add', this.handleAddEvent.bind(this));

      Kobo._mediator.register('kobo-message-box::clearAll');

      Kobo._mediator.subscribe('kobo-message-box::clearAll', this.handleClearAllEvent.bind(this));

      Kobo._mediator.register('kobo-message-box::clearMessageByName');

      Kobo._mediator.subscribe('kobo-message-box::clearMessageByName', this.handleClearMessageByNameEvent.bind(this));

      Kobo._mediator.register('kobo-message-box::storeMessage');

      Kobo._mediator.subscribe('kobo-message-box::storeMessage', this.handleStoreMessageEvent.bind(this));
    }
  }, {
    key: "handleAddEvent",
    value: function handleAddEvent(_, data) {
      var message = data.detail.message;
      if (!message || this.name !== message.recipientMessageBoxName) return;
      var messageViewModel = this.buildMessageViewModel(message);
      if (!messageViewModel) return;
      this.add(messageViewModel);
    }
  }, {
    key: "handleClearAllEvent",
    value: function handleClearAllEvent(_, data) {
      var recipientMessageBoxName = data.detail.recipientMessageBoxName;
      if (!recipientMessageBoxName || this.name !== recipientMessageBoxName) return;
      this.clearAll();
    }
  }, {
    key: "handleClearMessageByNameEvent",
    value: function handleClearMessageByNameEvent(_, data) {
      var _data$detail = data.detail,
          messageName = _data$detail.messageName,
          recipientMessageBoxName = _data$detail.recipientMessageBoxName;
      if (!messageName || !recipientMessageBoxName || this.name !== recipientMessageBoxName) return;
      var message = this.messages().find(function (message) {
        return message.messageName === messageName;
      });
      if (!message) return;
      this.clear(message);
    }
  }, {
    key: "handleStoreMessageEvent",
    value: function handleStoreMessageEvent(_, data) {
      var _data$detail2 = data.detail,
          messageKey = _data$detail2.messageKey,
          message = _data$detail2.message;
      if (!message || this.name !== message.recipientMessageBoxName) return;
      var messageViewModel = this.buildMessageViewModel(message);
      if (!messageViewModel) return;
      this.storeMessage(messageKey, messageViewModel);
    }
    /**
     * Initializes the message box with the provided messages.
     * @param {Array.<object>} messages
     * @returns
     */

  }, {
    key: "initializeWithMessages",
    value: function initializeWithMessages(messages) {
      var _this2 = this;

      if (!messages) {
        return;
      }

      messages.forEach(function (message) {
        var messageViewModel = _this2.buildMessageViewModel(message);

        _this2.add(messageViewModel);
      });
    }
  }, {
    key: "buildMessageViewModel",
    value: function buildMessageViewModel(messageData) {
      var _messageTypeViewModel;

      var messageTypeViewModelMap = (_messageTypeViewModel = {}, _defineProperty(_messageTypeViewModel, Kobo.Controls.MessageBox.MessageBoxType.Success, Kobo.Controls.MessageBox.SuccessMessageViewModel), _defineProperty(_messageTypeViewModel, Kobo.Controls.MessageBox.MessageBoxType.Error, Kobo.Controls.MessageBox.ErrorMessageViewModel), _defineProperty(_messageTypeViewModel, Kobo.Controls.MessageBox.MessageBoxType.Warning, Kobo.Controls.MessageBox.WarningMessageViewModel), _messageTypeViewModel);
      var messageType = messageData.messageType,
          headline = messageData.headline,
          body = messageData.body,
          htmlBody = messageData.htmlBody,
          messageName = messageData.messageName,
          messageBoxTemplate = messageData.messageBoxTemplate,
          recipientMessageBoxName = messageData.recipientMessageBoxName;
      var messageViewModel = messageTypeViewModelMap[messageType];

      if (!messageViewModel) {
        console.error("No view model found for message type ".concat(messageType, "."));
        return;
      }

      var messageViewModelOptions = {
        messageName: messageName,
        message: {
          headline: headline,
          body: body,
          htmlBody: htmlBody
        },
        messageBoxTemplate: messageBoxTemplate,
        recipientMessageBoxName: recipientMessageBoxName
      };
      return new messageViewModel(messageViewModelOptions);
    }
  }]);

  return MessageBoxViewModel;
}();

Kobo.Utilities.assignToNamespace('Kobo.Controls.MessageBox.MessageBoxViewModel', MessageBoxViewModel);